import { render } from "./PrinterGroup.vue?vue&type=template&id=9b3ae1fc&scoped=true"
import script from "./PrinterGroup.vue?vue&type=script&lang=js"
export * from "./PrinterGroup.vue?vue&type=script&lang=js"

import "./PrinterGroup.vue?vue&type=style&index=0&id=9b3ae1fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3ae1fc"]])

export default __exports__